import { Copy, Network } from "lucide-react";
import { SheetHeader, SheetTitle, SheetDescription } from "../ui/sheet";
import { TierBadge } from "../shared";

const btn = "h-9 px-3 rounded-md border border-[#334155] text-xs font-semibold flex items-center gap-1.5 hover:border-[#F59E0B] hover:text-[#F59E0B]";

export default function FactSheetHeader({ it, pol, onFlow, onDuplicate }) {
  return (
    <SheetHeader className="text-left mb-4">
      <div className="flex items-center justify-between gap-2 pr-8">
        <TierBadge tier={it.tier} />
        <div className="flex gap-2">
          {it.tier > 1 && <button data-testid="fact-bom-flowchart-btn" onClick={onFlow} className={btn}><Network className="w-3.5 h-3.5" />View BOM Flowchart</button>}
          {onDuplicate && <button data-testid="fact-duplicate-btn" onClick={() => onDuplicate(it)} className={btn}><Copy className="w-3.5 h-3.5" />Duplicate</button>}
        </div>
      </div>
      <SheetTitle className="font-display text-2xl text-white" data-testid="fact-title">{it.name}</SheetTitle>
      <SheetDescription className="sr-only">Item fact sheet for {it.name}</SheetDescription>
      <div className="font-mono text-xs text-[#6B7280]">{it.sku} · {it.category}
        {pol?.drifting && <span data-testid="fact-drift-tag" className="ml-2 px-1.5 py-0.5 rounded-sm bg-[#F59E0B]/15 text-[#F59E0B] font-bold">DRIFT {pol.par_drift_pct > 0 ? "+" : ""}{pol.par_drift_pct}% · SUGGESTED PAR {pol.suggested_par}</span>}
      </div>
    </SheetHeader>
  );
}
